<template>
    <div>
        <div v-for="(category,key) in categorysList" :key="key" class="goods_category">
            <img :src="require('assets/img/exchange/icon_body.png')" alt="">
            <div class="header_text">{{category.name}}</div>
            <Goods :goodsList="category.goods"></Goods>
        </div>
    </div>
</template>
<script>
    import Goods from '@/views/Exchange/Goods'
    import './index.less'
    export default {
        name:"categorysList",
        components:{
            Goods
        },
        props:{
            categorysList:Array
        }
    }
</script>
